import { Link } from "react-router-dom";
import bgImage from "../assets/images/1768687732162_3D.png";
import "./Welcome.css";

const Welcome = () => {
  return (
    <div
      className="welcome-container"
      dir="rtl"
      lang="ar"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="welcome-content">
        <center>
          <img src="/images/logo.png" alt="الشعار" className="welcome-image" />
        </center>

        <h1>مرحبًا بك في منصتنا</h1>

        <p>سجّل الدخول أو أنشئ حسابًا جديدًا للاستفادة من جميع خدماتنا.</p>

        <div className="auth-buttons">
          <Link to="/login" className="login-button">
            تسجيل الدخول
          </Link>

          <Link to="/register" className="register-button">
            إنشاء حساب
          </Link>
        </div>

        <p className="legal-text">
          بالمتابعة، فإنك توافق على <a href="/">شروط الاستخدام</a> و{" "}
          <a href="/">سياسة الخصوصية</a>.
        </p>
      </div>
    </div>
  );
};

export default Welcome;
